import React from 'react'
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Switch,
    Typography,
    makeStyles,
    Theme,
} from '@material-ui/core'

import { summarizeAllModeExit } from './exitFromLeadsUtils'
import { LEADS_EXIT_TRIGGER_OPTIONS } from './transitionTriggerCatalog'

const useStyles = makeStyles((theme: Theme) => ({
    overrideRow: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1, 1.5, 1.25),
        marginTop: theme.spacing(1.5),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
    },
    overrideLabel: {
        fontSize: '0.8125rem',
        color: theme.palette.text.secondary,
    },
}))

interface LeadsExitEdgeFieldsProps {
    triggers: string[]
    allowPmOverride: boolean
    readOnly?: boolean
    onTriggersChange: (triggers: string[]) => void
    onAllowPmOverrideChange: (value: boolean) => void
}

export const LeadsExitEdgeFields: React.FC<LeadsExitEdgeFieldsProps> = ({
    triggers,
    allowPmOverride,
    readOnly = false,
    onTriggersChange,
    onAllowPmOverrideChange,
}) => {
    const classes = useStyles()

    const toggleTrigger = (trigger: string, checked: boolean) => {
        const next = new Set(triggers)
        if (checked) {
            next.add(trigger)
        } else {
            next.delete(trigger)
        }
        onTriggersChange(Array.from(next))
    }

    return (
        <>
            <Typography variant="subtitle2" gutterBottom>
                Leave Leads when
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
                A person advances when all selected conditions are complete.
            </Typography>

            <FormGroup style={{ marginBottom: 8 }}>
                {LEADS_EXIT_TRIGGER_OPTIONS.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        control={
                            <Checkbox
                                checked={triggers.includes(option.value)}
                                onChange={(_, checked) =>
                                    toggleTrigger(option.value, checked)
                                }
                                disabled={readOnly}
                                color="primary"
                            />
                        }
                        label={option.label}
                    />
                ))}
            </FormGroup>

            <Box className={classes.overrideRow}>
                <Typography className={classes.overrideLabel}>
                    Allow PM to advance manually before all conditions are met
                </Typography>
                <Switch
                    checked={allowPmOverride}
                    onChange={(_, checked) => onAllowPmOverrideChange(checked)}
                    disabled={readOnly}
                    color="primary"
                    size="small"
                />
            </Box>

            <Typography
                variant="caption"
                color="textSecondary"
                display="block"
                style={{ marginTop: 12 }}
            >
                Summary: {summarizeAllModeExit(triggers, allowPmOverride)}
            </Typography>
        </>
    )
}
